import { RuleObject } from 'antd/lib/form';

import i18n from '~/i18n';

export type Validator = RuleObject['validator'];

export const basicValidation: (v: Validator) => Validator = (v) => (rule, value, callback) => {
  if (rule.required && !value) {
    callback(i18n.t('Required', { ns: 'validation' }));
  } else if (value) {
    v?.(rule, value, callback);
  } else {
    callback();
  }
};

export const nameValidatorRules = [
  {
    pattern: /^(?:[a-zA-Z]+(?:\s[a-zA-Z]+)?)$/,
    message: i18n.t('Please enter a valid name with alphabets and single spaces only.'),
  },
  {
    max: 40,
    message: i18n.t('Name must be less than or equal to 40 characters.'),
  },
];

export const nameValidatorRulesuSERS = [
  {
    pattern: /^[a-zA-Z ]*$/,
    message: i18n.t('Please enter a valid name with alphabets.'),
  },
  {
    max: 40,
    message: i18n.t('Name must be less than or equal to 40 characters.'),
  },
];
